<template>
  <div>
    <div
      aria-live="assertive"
      class="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start z-hard"
    >
      <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
        <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
        <transition
          enter-active-class="animate__animated animate__fadeInRight animate__fast"
          leave-active-class="animate__animated animate__fadeOutRight animate__fast"
        >

          <div
            v-if="showConfirm"
            :class="status == 'success' ? 'bg-green-50 border-l-4 border-green-500 text-green-500':'bg-red-50 border-l-4 border-red-500 text-red-500'"
            class="max-w-sm w-full shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden"
          >
            <div class="px-4 py-7">
              <div class="flex items-start">
                <svg
                  v-if="status == 'success'"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <svg
                  v-if="status == 'error'"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <div class="ml-3 w-0 flex-1 pt-0.5">
                  <p
                    class="text-sm font-medium "
                    :class="status == 'success' ? 'text-green-900':'text-red-900'"
                  >
                    {{$t(msg)}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </transition>

      </div>
    </div>
    <form @submit.prevent="resetPass">
      <div class="h-screen w-screen flex items-start lg:pt-32 jcc z-hard">
        <div class="flex flex-col auth-area">
          <div class="rounded-4xl text-left transform transition-all">
            <div>
              <div class="flex flex-col w-full space-y-2">
              <div class="flex aic jcb mb-12 bg-gray-50 p-4 text-primary-dark border-l-4 border-green-600 animation a1">
                <span class="auth-text-top uppercase tracking-wider">{{$t("Change Password")}}</span>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z" />
                </svg>
                <!-- <span class="text-sm text-gray-500 tracking-wider whitespace-nowrap animation a2">{{$t("Please enter your information")}}</span> -->
              </div>
                <div class="flex flex-col aic jcb mt-4 mb-8"></div>
              </div>
              <div class="flex flex-col space-y-4 form">
                <span class="text-sm text-gray-500 tracking-wider whitespace-nowrap animation a2">{{$t("Please set your new password")}}</span>
                <div>
                  <div class="animation a3">
                    <input
                      type="password"
                      name="password"
                      id="password"
                      v-model="password"
                      required
                      class="w-full shadow-md h-60p px-5 lg:py-6 border border-gray-100 text-sm md:text-base"
                      aria-label="password"
                      placeholder="Password"
                    />
                  </div>
                </div>
                <div>
                  <div class="animation a4">
                    <input
                      type="password"
                      name="confirmPassword"
                      id="confirmPassword"
                      v-model="confirmPassword"
                      required
                      class="w-full shadow-md h-60p px-5 lg:py-6 border border-gray-100 text-sm md:text-base"
                      aria-label="confirmPassword"
                      placeholder="confirm Password"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex flex-col md:flex-row space-y-8 md:space-y-0 aic jce mb-16 lg:mb-32 mt-16 animation a5">

              <button
                type="submit"
                class="inline-flex justify-center w-full md:max-w-max border border-transparent relative px-16 py-3 btn-primary"
              >
                {{$t("Reset")}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "ResetPass",
  data() {
    return {
      password: null,
      confirmPassword: null,
      hasError: false,
      passwordError: false,
      showConfirm: false,
    };
  },
  computed: {
    restaurantInfo() {
      return this.$store.state.orderiomApiPackage.restaurant.restaurantInfo;
    },
    logo() {
      return process.env.VUE_APP_LOGO;
    },
    token() {
      return this.$route.params.token;
    },
    email() {
      return this.$store.state.orderiomApiPackage.auth.email;
    },
  },
  methods: {
    msg(msg) {
      return this.$t(msg);
    },
    checkToken() {
      this.$store.dispatch("auth/checkToken", this.token).then((res) => {
        if (res.type == "error") {
          this.hasError = true;
          this.$swal({
            title: this.msg(res.msg),
            showClass: {
              popup: "swal2-show md-warning",
            },
          });
        }
      });
    },
    resetPass() {
      if (this.password == this.confirmPassword) {
        this.$store
          .dispatch("auth/resetPassword", {
            email: this.email,
            token: this.token,
            password: this.password,
          })
          .then((res) => {
            if (res.type == "success") {
              this.$swal({
                title: this.msg(res.msg),
                showClass: {
                  popup: "swal2-show md-success",
                },
              }).then((res) => {
                if (res.isConfirmed) {
                  // this.$store.dispatch("auth/fetchUser");
                  this.$router.push("/");
                }
              });
            } else {
              this.$swal({
                title: this.$t(res.msg),
                showClass: {
                  popup: "swal2-show md-warning",
                },
              });
            }
          });
      } else {
        this.passwordError = true;
      }
    },
  },
  created() {
    this.checkToken();
  },
};
</script>

<style>
</style>